import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  DetailDrawer,
  InnoTable,
  Popover,
  TableList,
  Tabs,
} from "InnoUI/components";
import SC from "./style";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { apiGet } from "api/callApi";
import TooltipText from "components/TooltipText";
import theme, { getBorderColor } from "@theme";
import { requestType, requestTypeForUpdate } from "utils/optionData/utils";
import JournalDetails from "./JournalDetails";
import debounce from "lodash.debounce";
import CustomBreadcrumb from "components/CustomBreadcrumb";
import EmailDetailsTooltip from "components/EmailDetailsTooltip";
import TimezoneConverter from "components/TimeZoneConvertor";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import OccupantFilterDropdown from "components/OccupantFilterDropdown";
import { formatAlarmDateTime } from "utils/helper";
import CheckPermissionWrapper from "components/CheckPermissionWrapper";
import { userAccessType } from "utils/lookUpTable";
import PointIdIndicatorInJournal from "components/PointIdIndicatorInJournal";
dayjs.extend(customParseFormat);

const Journal = (props) => {
  const { popupState } = props;
  const [data, setData] = useState();
  const [record, setTotalRecord] = useState();
  const [selectedTab, setSelectedTab] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const projectId = searchParams.get("projectId");
  const folderId = searchParams.get("folderId");
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [filters, setFilters] = useState({
    requestType: null,
    searchValue: null,
    propertyIds: null,
    roles: null,
  });

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || [],
  );
  const roleOptionData = useSelector(
    (state) => state?.roleOptionData?.data || [],
  );

  const occupantOption = useSelector(
    (state) => state?.occupantOption?.data || [],
  );
  const currentOccupant = useSelector(
    (state) => state?.currentOccupant?.data || {},
  );

  const projectNameFilter = {
    filters: [
      ...(Array.isArray(occupantOption)
        ? occupantOption.map((option) => ({
            text: option?.occupantName,
            value: option?.id,
          }))
        : []),
    ],
    onFilter: (value, record) => {
      return true;
    },
    filterSearch: true,
    // filterMode: "tree",
  };

  const requestFilter = {
    filters: requestTypeForUpdate.map((option) => ({
      text: option.label,
      value: option.id,
    })),
    onFilter: (value, record) => {
      return true;
    },
    filterSearch: true,
    // filterMode: "tree",
  };

  const roleFilter = {
    filters: roleOptionData.map((option) => ({
      text: option.role,
      value: option.id,
    })),
    onFilter: (value, record) => {
      return true;
    },
    filterSearch: true,
    // filterMode: "tree",
  };

  const getJournalData = async () => {
    try {
      setIsLoading(true);
      const { requestType, searchValue, propertyIds, roles } = filters;
      let url = `/v1/journal?projectId=${projectId}&type=${type}&pageSize=${pageSize}&pageNo=${currentPage}`;

      if (requestType) {
        url = `${url}&requestType=${requestType}`;
      }
      if (searchValue && searchValue.trim() !== "") {
        url += `&searchValue=${searchValue.trim()}`;
      }
      if (propertyIds) {
        url += `&propertyIds=${propertyIds}`;
      }
      if (roles) {
        url += `&roles=${roles}`;
      }
      if (selectedTab == 0 || selectedTab == 1) {
        url = `${url}&status=${selectedTab ? 0 : 1}`;
      }
      const response = await apiGet(url, false);
      setIsLoading(false);
      setTotalRecord(response);
      const journalData = Array.isArray(response.data) ? response.data : [];
      setData(journalData);
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getJournalData();
  }, [pageSize, currentPage, filters, projectId, selectedTab]);

  const handlePagination = (page, pageSize) => {
    setPageSize(pageSize);
    setCurrentPage(page);
  };

  const debouncedSearch = useCallback(
    debounce((query) => {
      setFilters((prevFilters) => ({ ...prevFilters, searchValue: query }));
      setCurrentPage(1);
    }, 500),
    [],
  );

  const handleSearch = useCallback(
    (event) => {
      const query = event.target.value.trim();

      // Update searchValue in filters with debounce
      if (query === "") {
        // Reset the search filter and fetch data
        setFilters((prevFilters) => ({ ...prevFilters, searchValue: null }));
        setCurrentPage(1);
      } else {
        // Only debounce valid search queries
        debouncedSearch(query);
      }
    },
    [debouncedSearch],
  );

  const onRowClick = useCallback(() => {}, []);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const tabData = [
    {
      value: 1,
      label: (
        <div style={{ display: "flex" }}>
          <span>Active Journals</span>
          <span style={{ color: theme.colors.themeColor, marginLeft: "5px" }}>
            ({record?.totalActive})
          </span>
        </div>
      ),
    },
    {
      value: 2,
      label: (
        <div style={{ display: "flex" }}>
          <span> Closed Journal</span>
          <span style={{ color: theme.colors.themeColor, marginLeft: "5px" }}>
            ({record?.totalClosed})
          </span>
        </div>
      ),
    },
  ];

  const onAddDataCallback = () => {
    navigate(
      `/journal/add-journal?projectId=${projectId}&folderId=${folderId}&type=${type}`,
    );
  };
  const onAddDataBulkJournal = () => {
    navigate(
      `/bulk-journal?projectId=${projectId}&folderId=${folderId}&type=${type}`,
    );
  };

  const handleUpdate = (record) => {
    navigate(
      `/journal/update-journal?projectId=${projectId}&folderId=${folderId}&type=${type}&journalId=${record.id}`,
    );
  };

  const handleThread = (record) => {
    console.log(record, "resor");

    navigate(
      `/journal/open-thread?projectId=${projectId}&folderId=${folderId}&type=${type}&journalId=${record.id}`,
    );
  };

  const handleJournalClick = (record) => {
    setSelectedRow(record.id);
    setOpen(true);
  };

  const closeDrawer = () => {
    setOpen(false);
  };

  const journalColumn = [
    {
      title: "Ingested",
      width: 50,
      dataIndex: "pointId",
      render(value, record) {
        return record.pointId ? <PointIdIndicatorInJournal /> : "--";
      },
    },
    {
      title: "Journal Subject",
      width: 350,
      dataIndex: "subject",
      render(value, record) {
        const menuItems = [
          {
            id: 1,
            text: "Open Thread",
            onClick: (e) => {
              e.stopPropagation();
              handleThread(record);
            },
          },

          // {
          //   id: 2,
          //   text: "Update",
          //   onClick: (e) => {
          //     e.stopPropagation();
          //     handleUpdate(record);
          //   },
          // },
        ];

        return (
          <SC.PopoverContainer>
            {value}

            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <div
                    style={{
                      width: "50px",
                      textAlign: "center",
                      justifyContent: "end",
                      display: "flex",
                      marginRight: "5px",
                    }}
                  >
                    <SC.PopoverSpan>
                      <SC.MoreVertIcon />
                    </SC.PopoverSpan>
                  </div>
                ),
              }}
              popoverContent={
                <TableList
                  sx={{
                    borderBottom: `1px solid ${theme.colors.bordertask}`,
                  }}
                  items={menuItems}
                  popupState={popupState}
                />
              }
            />
          </SC.PopoverContainer>
        );
      },
    },
    {
      title: "Request Type",
      width: 150,
      dataIndex: "requestType",
      render(value, record) {
        const request = requestTypeForUpdate.find((item) => item.id === value);
        return <p>{request ? request.label : "Unknown"}</p>;
      },
      ...requestFilter,
    },
    {
      title: "Request To",
      width: 200,
      dataIndex: "roles",
      render(value, record) {
        return value ? (
          <Popover
            sx={{
              cursor: "pointer",
            }}
            buttonLabel={{
              icon: <SC.ParagaphStyle>{value}</SC.ParagaphStyle>,
            }}
            popoverContent={
              <SC.Table>
                <SC.Thead>
                  <SC.TR>
                    <SC.Th>Roles</SC.Th>
                  </SC.TR>
                </SC.Thead>
                <SC.Tbody>
                  <SC.Tr>
                    <SC.Td>{value || "N/A"}</SC.Td>
                  </SC.Tr>
                </SC.Tbody>
              </SC.Table>
            }
          />
        ) : (
          "N/A"
        );
      },
      ...roleFilter,
    },

    {
      title: "To",
      width: 200,
      dataIndex: "sendTo",
      render(value, record) {
        return <EmailDetailsTooltip data={record?.sendToWithName} />;
      },
    },
    {
      title: "Created By",
      width: 150,
      dataIndex: "createdByName",
      render(value, record) {
        return <p>{value}</p>;
      },
    },

    {
      title: "Created Date & Time",
      width: 210,
      dataIndex: "createdOn",
      render(value, record) {
        return (
          <p>
            <TimezoneConverter time={value} />
          </p>
        );
      },
    },
    {
      title: "Alarm set for",
      width: 210,
      render(value, record) {
        const alarmData = record?.alarmData || [];
        const primaryAlarms = alarmData.filter(
          (alarm) => alarm.alarmType === 0,
        );
        if (!primaryAlarms.length) return <p>-</p>;
        const { alarmDate, alarmTime } = primaryAlarms[0];
        return <p>{formatAlarmDateTime(alarmDate, alarmTime)}</p>;
      },
    },
  ];

  if (type == 0) {
    journalColumn.splice(4, 0, {
      title: "Property Name",
      width: 150,
      dataIndex: "propertyName",
      render(value, record) {
        return <p>{value}</p>;
      },
      ...projectNameFilter,
    });
  }

  const onFilterChange = (data) => {
    const { requestType, propertyName, roles } = data;
    setFilters({
      ...filters,
      requestType: requestType,
      propertyIds: propertyName,
      roles: roles,
    });
  };

  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: true,
    addNew: false,
    search: false,
    action: false,
    divBorder: false,
    sno: false,
    addDummyData: false,
    pagination: {
      total: selectedTab == 0 ? record?.totalActive : record?.totalClosed,
      current: currentPage,
      defaultCurrent: currentPage,
      pageSize: pageSize,
      onChange: (page, pageSize) => {
        handlePagination(page, pageSize);
      },
      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
      itemRender: (_, type, originalElement) => {
        if (type === "prev") {
          return <a>Previous</a>;
        }
        if (type === "next") {
          return <a>Next</a>;
        }
        return originalElement;
      },
    },
  };

  return (
    <>
      <CustomBreadcrumb />

      <SC.BodyContainerg>
        <SC.FilterContainer>
          <OccupantFilterDropdown />
        </SC.FilterContainer>
      </SC.BodyContainerg>

      <CheckPermissionWrapper>
        {({ permission }) => (
          <>
            <>
              <SC.MainContainer>
                <SC.TabDiv>
                  <SC.HeaderContainer>
                    <SC.HeaderStyle>Journal</SC.HeaderStyle>
                    <SC.CountStyle>({record?.totalCount})</SC.CountStyle>
                  </SC.HeaderContainer>

                  <form
                    autoComplete="off"
                    onSubmit={(event) => {
                      event.preventDefault();
                    }}
                  >
                    <SC.InputContiner>
                      <SC.SearchIcon />
                      <SC.InputStyle
                        placeholder="Search journal"
                        name="searchJournal"
                        onChange={handleSearch}
                        autoComplete="off"
                      />
                    </SC.InputContiner>
                  </form>
                </SC.TabDiv>

                {permission == userAccessType.write && (
                  <div style={{ display: "flex", gap: "10px" }}>
                    <Button
                      caption={"+ New Journal"}
                      type="submit"
                      onClick={onAddDataCallback}
                      color="white"
                      fontSize="12px"
                      style={{
                        marginBottom: 8,
                        background: theme.gradient.themeGradient,
                        color: theme.colors.white,
                        minWidth: "100px",
                        height: "30px",
                        borderRadius: "3px",
                      }}
                    />
                    {type == 0 && (
                      <Button
                        caption={"+ Bulk Journal"}
                        type="submit"
                        onClick={onAddDataBulkJournal}
                        color="white"
                        fontSize="12px"
                        style={{
                          marginBottom: 8,
                          background: theme.gradient.themeGradient,
                          color: theme.colors.white,
                          minWidth: "100px",
                          height: "30px",
                          borderRadius: "3px",
                        }}
                      />
                    )}
                  </div>
                )}
              </SC.MainContainer>
              <SC.TabContainer>
                <Tabs
                  value={selectedTab}
                  label={tabData.map((tab) => tab.label) || []}
                  onChange={handleTabChange}
                  selectedValue={selectedTab}
                />
              </SC.TabContainer>

              <div>
                {selectedTab == 0 && (
                  <InnoTable
                    tableConfig={tableConfig}
                    padding={"4px 8px 6px 8px"}
                    column={journalColumn}
                    data={data}
                    onRowClickCallback={onRowClick}
                    tableKey={"Journal"}
                    loading={isLoading}
                    searchKeys={["propertyName", "displayTemplateName"]}
                    onAddDataCallback={onAddDataCallback}
                    onFilterChange={onFilterChange}
                    onRow={(record) => ({
                      onClick: (event) => {
                        setTimeout(() => {
                          if (
                            !document.querySelector(".ant-image-preview-mask")
                          ) {
                            handleJournalClick(record);
                          }
                        }, 100);
                      },
                    })}
                  />
                )}
                {selectedTab == 1 && (
                  <InnoTable
                    tableConfig={tableConfig}
                    padding={"4px"}
                    column={journalColumn}
                    data={data}
                    onRowClickCallback={onRowClick}
                    tableKey={"Journal"}
                    loading={isLoading}
                    searchKeys={["propertyName", "displayTemplateName"]}
                    onAddDataCallback={onAddDataCallback}
                    onFilterChange={onFilterChange}
                    // borderleft="none"
                    onRow={(record) => ({
                      onClick: (event) => {
                        setTimeout(() => {
                          if (
                            !document.querySelector(
                              ".ant-image-preview-mask",
                              ".MuiPopover-paper",
                            )
                          ) {
                            handleJournalClick(record);
                          }
                        }, 100);
                      },
                    })}
                  />
                )}
              </div>
            </>

            {open && (
              <DetailDrawer
                open={open}
                onClose={closeDrawer}
                title={false}
                closable={true}
                width={"970px"}
                children={
                  <JournalDetails
                    onClose={closeDrawer}
                    selectedRowId={selectedRow}
                    fetchData={getJournalData}
                    permission={permission}
                  />
                }
              ></DetailDrawer>
            )}
          </>
        )}
      </CheckPermissionWrapper>
    </>
  );
};

export default Journal;
